export const resolveAuthToken = ({ sessionData, storedToken }) => {
  if (sessionData?.token && typeof sessionData.token === 'string') {
    return sessionData.token;
  }
  if (storedToken && typeof storedToken === 'string') {
    return storedToken;
  }
  return null;
};

const RECOVERY_FIELDS = [
  'isRecoveryMode',
  'recoveryDaysCompleted',
  'recoveryModeStartDate',
];

export const mergeAuthenticatedUser = (previousUser, nextUser) => {
  if (!nextUser || typeof nextUser !== 'object') {
    return nextUser;
  }
  if (!previousUser || typeof previousUser !== 'object') {
    return nextUser;
  }

  const merged = { ...nextUser };
  RECOVERY_FIELDS.forEach((field) => {
    if (merged[field] === undefined && previousUser[field] !== undefined) {
      merged[field] = previousUser[field];
    }
  });
  return merged;
};
